import { createUuid4 } from '@gov-nx/utils/common';

export const createWizardId = () => createUuid4('wizard');
